// extracted by mini-css-extract-plugin
export default {"card":"nu0VKgba","content":"Dsw9ZIWF","imgBox":"SbbYTmJ2","img":"aFxY16bc","button":"DSNNgMkt","hasBackgroundImage":"Dmy3k5_A","hidden":"wPPshk1f"};
    if(module.hot) {
      // 1717522983550
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  